import React from "react";
import { Link } from "react-router-dom";
import FabstouchLogo from "../../images/fabtouch-logo.png";

const Logo = () => {
  return (
    <Link to={`${process.env.PUBLIC_URL}/`} className="logo-link">
      <img className="logo-light logo-img" src={FabstouchLogo} alt="logo" />
      <img className="logo-dark logo-img" src={FabstouchLogo} alt="logo" />
      <img className="logo-small logo-img logo-img-small" src={FabstouchLogo} alt="logo" />
    </Link>
  );
};

export default Logo;
